import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, TableRow, Tooltip } from '@mui/material';
import TableCell from 'src/components/Table/TableCell';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useTranslation } from 'react-i18next';
import MoreMenu from 'src/components/MoreMenu/MoreMenu';

const BureauExclusionsRow = ({ onEdit }) => {
  const { t } = useTranslation();

  return (
    <TableRow hover>
      <TableCell>{t('PARAMETER_VIEW.BUREAU_EXCLUSIONS_TITLE')}</TableCell>
      <TableCell align="center">
        <Tooltip title={t('COMMON.VIEW_LIST')}>
          <IconButton color="primary" aria-label="view_list" onClick={onEdit}>
            <VisibilityIcon />
          </IconButton>
        </Tooltip>
      </TableCell>
      <TableCell style={{ width: 130 }}>
        <MoreMenu deleteDisabled handleClickOption={onEdit} />
      </TableCell>
    </TableRow>
  );
};

BureauExclusionsRow.propTypes = {
  onEdit: PropTypes.func.isRequired
};

export default BureauExclusionsRow;
